declare global {
  interface Window {
    fbq: any;
  }
}

export const useFacebookPixel = () => {
  const pixelCreateCustomTracker = ({
    eventId,
    props = {},
  }: {
    eventId: string;
    props: any;
  }) => {
    if (window?.fbq) {
      console.debug("success to add fb pixel", eventId);
      window.fbq("trackCustom", eventId, props);
    }
  };

  return {
    isHavePixelIntegration: !!process.env.REACT_APP_FB_PIXEL_ID,
    pixelCreateCustomTracker,
  };
};
